import actionCreatorFactory from "typescript-fsa";
import { StoreLikeRequestBody } from "../../core/api/requests/store/like/types";
import { StoreSearchRequestBody } from "../../core/api/requests/store/search/types";
import { CommonAsyncType } from "../../core/types";
import { Store } from "./types";

const actionCreator = actionCreatorFactory("@@Store");

export const storeActions = {
  getStores: actionCreator.async<CommonAsyncType<Store[]> & StoreSearchRequestBody, Store[]>("GET_STORES"),
  setFavoriteStore: actionCreator.async<CommonAsyncType & StoreLikeRequestBody, {}>("SET_FAVORITE_STORE"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
